/**
 * An entry's scanned fields as spdata-api reads them back (ENG-10005, ADR 0016): each field whose saved answer still
 * equals what an application of a scan wrote, with that scan. The server makes the comparison; the client only draws
 * the result, as the "Scanned" chip on the field and the "Values from" notice over the fields.
 */

/** `GET pump/:id/case/:caseId/entry/:entryId/scan-applications`, one row per scanned field. */
export interface IScannedFieldsResponse {
  scannedFields: IScannedField[];
}

export interface IScannedField {
  variable: string;
  /** The field's `identifier`, the key the entry's answers are stored under. */
  fieldId: string;
  scan: {
    id: string;
    machineName: string;
    documentType: string | null;
    capturedAt: string | null;
    createdAt: string;
    /** The scan was deleted. The field keeps its value, and the clients say the scan is gone. */
    archived: boolean;
  };
  appliedAt: string;
  appliedBy: { id: string; name: string | null } | null;
}

/** The scan a scanned field's answer came from, as the chip and the notice name it. */
export interface ScannedFieldScan {
  id: string;
  machineName: string;
  /** When the scan was made: its `capturedAt`, else when the server stored it, as `PerfusionScanModel.recordedAt`. */
  recordedAt: Date;
  archived: boolean;
}

export interface ScannedField {
  variable: string;
  fieldId: string;
  scan: ScannedFieldScan;
}

export const mapScannedFields = (response: IScannedFieldsResponse): ScannedField[] =>
  (response.scannedFields ?? []).map(({ variable, fieldId, scan }) => ({
    variable,
    fieldId,
    scan: {
      id: scan.id,
      machineName: scan.machineName,
      recordedAt: new Date(scan.capturedAt ?? scan.createdAt),
      archived: scan.archived
    }
  }));
